const LEFT_DOUBLE_QUOTATION_MARK = '\u201c';
const RIGHT_DOUBLE_QUOTATION_MARK = '\u201d';

export let replaceAt = (string, index, replacement) => {
  return string.substr(0, index) + replacement +
    string.substr(index + replacement.length);
};

export let replaceQuoteMark = (el, isFirst, replaceWith) => {
  let child = isFirst ? el.firstChild : el.lastChild;
  while (child) {
    if (child.nodeType === 3) {
      let quoteMarkIndex = isFirst ? child.data.indexOf('"') : child.data.lastIndexOf('"');
      if (quoteMarkIndex !== -1) {
        child.data = replaceAt(child.data, quoteMarkIndex, replaceWith);
        return true;
      }
    } else if (child.nodeType === 1) {
      if (replaceQuoteMark(child, isFirst, replaceWith)) {
        return true;
      }
    }
    child = isFirst ? child.nextSibling : child.previousSibling;
  }
  return false;
};

export let replaceQuoteMarks = (el) => {
  replaceQuoteMark(el, true, LEFT_DOUBLE_QUOTATION_MARK);
  replaceQuoteMark(el, false, RIGHT_DOUBLE_QUOTATION_MARK);
};
